module.exports = __webpack_public_path__ + "static/media/arrow-button.7dd1af45.png";